import { i18n } from "@v2/shared/config";
export default function getError(axiosResponse) {
  const errors = axiosResponse.error_data?.response?.data?.errors;
  const message = axiosResponse.error_data?.response?.data?.message;
  if (errors && Object.keys(errors).length) {
    return Object.values(errors)
      .flat(Infinity)
      .join("<br/>");
  }
  return message || i18n.t("common.error");
}
